import * as React from "react";
import { useState } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Typography,
} from "@mui/material";
import { OrderPaymentStatusEnum } from "src/common/enum";
import { priceFormat } from "src/common/UtilFunctions";

export const TransactionTable = (props) => {
    const { record, ...rest } = props;

    return (
        <TableContainer sx={{border: "1px solid #ebebeb", borderRadius: "8px", boxShadow: "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)"}}>
            <Table size="small">
                <TableHead>
                <TableRow>
                    <TableCell>
                    Id
                    </TableCell>
                    <TableCell>
                    Service
                    </TableCell>
                    <TableCell>
                    Card
                    </TableCell>
                    <TableCell>
                    Amount
                    </TableCell>
                    <TableCell>
                    Captured Amount
                    </TableCell>
                    <TableCell>
                    Payment ID
                    </TableCell>
                    <TableCell>
                    Description
                    </TableCell>
                    <TableCell>
                    Status
                    </TableCell>
                </TableRow>
                </TableHead>

                <TableBody>
                { record.payments.map((paymentItem, paymentItemIndex) => {
                    let statusEnum = OrderPaymentStatusEnum.find((status) => status.id === paymentItem.status);

                    return (
                        <>
                        <TableRow key={`row_${paymentItemIndex}`} >
                            <TableCell>
                            {paymentItem.id}
                            </TableCell>
                            <TableCell>
                            Stripe
                            </TableCell>
                            <TableCell  sx={{width: "100px"}}>
                                <Typography variant="body2">{paymentItem.card_brand}</Typography>
                                <Typography variant="body2">{`xxxx-${paymentItem.card_ending}`}</Typography>
                                <Typography variant="body2">{`${paymentItem.card_exp_month}/${paymentItem.card_exp_year}`}</Typography>
                            </TableCell>
                            <TableCell>
                            {priceFormat(paymentItem.amount, record.currency)}
                            </TableCell>
                            <TableCell>
                            {priceFormat(paymentItem.captured_amount, record.currency)}
                            </TableCell>
                            <TableCell>
                            {paymentItem.stripe_payment_id}
                            </TableCell>
                            <TableCell>
                            {paymentItem.description}
                            </TableCell>
                            <TableCell>
                                <Chip sx={{fontSize: "12px", padding: "4px 6px", height: "auto"}} label={statusEnum.name} color="primary"/>
                            </TableCell>
                        </TableRow>
                        </>
                    )   
                })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
